import {Outlet} from "react-router";

const AdminOrders = () => {
    return <Outlet>Available, View</Outlet>
}
export default AdminOrders